<template>
  <div id="app">
    <div class="box mx-6">
      <!-- <img src="error.png" alt="error" class="center" /> -->
      <HeaderSection />
      <section v-if="loggedIn">
        <nav id="nav">
          <router-link v-bind:to="{ name: 'home' }"
            ><i class="fas fa-home fa-2x has-text-success mr-4"></i
          ></router-link>
          <router-link
            v-bind:to="{ name: 'logout' }"
            v-if="$store.state.token != ''"
            ><i
              class="fas fa-sign-out-alt has-text-danger fa-2x"
              title="logout"
            ></i
          ></router-link>
        </nav>
        <main class="columns mt-5">
          <div class="column is-one-third">
            <HomePage id="profile" />
          </div>
          <div class="column">
            <router-view id="main-content" />
          </div>
        </main>
      </section>
      <section v-else>
        <router-view id="main-content" />
      </section>
    </div>
    <div class="mx-5">
      <h6 class="is-size-7 has-text-right has-text-grey-lighter" style="width: 100%">
        {{ $version }}
      </h6>
    </div>
  </div>
</template>

<script>
import HomePage from "@/views/HomePage.vue";
import HeaderSection from "@/components/HeaderSection.vue";

export default {
  name: "app",
  components: {
    HeaderSection,
    HomePage,
  },
  computed: {
    loggedIn() {
      return this.$store.state.token.trim().length > 0;
    },
  },
};
</script>

<style>
/*
#app {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
}
.center {
  height: 65%;
}
*/
/* body {
  background-color: rgba(0,140,255,.05);
}
#nav {
  background-color: #fff;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
main {
  display: grid;
  grid-template-columns: 1fr 4fr;
  grid-template-areas: "profile news-feed";
  grid-gap: 10px;
}
#profile {
  border: solid 1px black;
  grid-area: "profile";
}
#main-content {
  border: solid 1px black;
  grid-area: "news-feed";
} */
</style>